
import { AxiosResponse } from 'axios';
import { OAuth2Client } from '@kolorado/oauth';
import {PanelConfigDeletePayload, PanelConfigGetResponse, PanelConfigPatchPayload, PanelConfigPostPayload, PanelConfigPostResponse, QueueConfigRequestPayload } from './types';
import { axiosInstance } from "../axios-instance";
import {deleteConfigManagementResponseBody,QueueConfigManagementResponseBody} from '../entities/config-management-v1/queue-configs-response-body';

class PanelConfigurationManagement {
  private authClient: OAuth2Client | null;

  private baseUrl: string;

  constructor(authClient: OAuth2Client | null, baseUrl: string) {
    this.authClient = authClient;
    this.baseUrl = baseUrl;
  }

  queuePanelConfiguration(
    input: PanelConfigPostPayload,
  ): Promise<AxiosResponse<PanelConfigPostResponse>> {
    const accessToken = localStorage.getItem('accessToken');
    return axiosInstance.post<PanelConfigPostResponse >(`${this.baseUrl}/configs`, input, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      }
    });
  }

  getPanelConfigurations(
    input: any,
  ): Promise<AxiosResponse<PanelConfigGetResponse>> {
    const accessToken = localStorage.getItem('accessToken');
    return axiosInstance.get<PanelConfigGetResponse>(`${this.baseUrl}/configs`, {
      params: input,
      headers: {
        Authorization: `Bearer ${accessToken}`,
      }
    });
  }

  updatePanelConfiguration(
    input: PanelConfigPatchPayload,
  ): Promise<AxiosResponse<QueueConfigManagementResponseBody>> {
    const accessToken = localStorage.getItem('accessToken');
    return axiosInstance.patch<QueueConfigManagementResponseBody>(`${this.baseUrl}/configs`, input, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      }
    });
  }

  deletePanelConfiguration(
    input: PanelConfigDeletePayload
  ): Promise<AxiosResponse<deleteConfigManagementResponseBody>> {
    const accessToken = localStorage.getItem('accessToken');
    return axiosInstance.post<deleteConfigManagementResponseBody>(
      `${this.baseUrl}/configs/bulkDeletion`,
      input,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        }
      },
    );
  }
}

export default  PanelConfigurationManagement;
